import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { ConsumerGenerator } from '../components/_organisms/DesignerTabPane/GeneratorsTab/utils';
import BackendService from '../services/backendService';

export const useGetPublicCollectedGenerators = (collectionId: string) => {
  const {
    data: collectedGenerators,
    isFetching: isFetchingCollectedGenerators,
    isFetchingNextPage: isFetchingNextPageCollectedGenerators,
    hasNextPage: hasNextPageCollectedGenerators,
    fetchNextPage: fetchNextPageCollectedGenerators,
  } = useInfiniteQuery<{ items: ConsumerGenerator[]; cursor: number; total: number }>(
    ['public-collected-generators', collectionId],
    ({ pageParam = 0 }) => {
      return BackendService.instance.generators.publicListByIds({
        limit: 20,
        cursor: pageParam,
        collectionId: collectionId,
      });
    },
    {
      staleTime: 1000 * 60 * 5,
      getNextPageParam: lastPage => {
        return lastPage.cursor;
      },
    },
  );

  const collectedGeneratorsItems = useMemo(
    () => collectedGenerators?.pages?.flatMap(page => page.items) || [],
    [collectedGenerators?.pages],
  );

  return {
    collectedGenerators: collectedGeneratorsItems,
    isFetchingCollectedGenerators,
    isFetchingNextPageCollectedGenerators,
    hasNextPageCollectedGenerators,
    fetchNextPageCollectedGenerators,
  };
};

const useGetCollectedGenerators = (collectionId: string, generatorIds: string[]) => {
  const {
    data: collectedGenerators,
    isFetching: isFetchingCollectedGenerators,
  } = useQuery(
    ['collected-generators', collectionId],

    () => {
      if (generatorIds.length === 0) return [];
      return BackendService.instance.generators.listByIds(generatorIds.map(s => s));
    },
    {
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    collectedGenerators,
    isFetchingCollectedGenerators,
  };
};

export default useGetCollectedGenerators;
